import {
    DeleteStoryParams,
    DeleteSubplanParams,
    DeleteZoneParams,
    GetPlanLanguagesParams,
    GetStoryByIdParams,
    GetStoryLanguagesParams,
    GetSubplanbyIdParams,
    GetZoneByIdParams,
    GetZoneLanguagesParams,
    GetZonesAndRoomsParams,
    SaveGroupedSubPlanParams,
    SaveStoryParams,
    SaveSubPlanParams,
    SaveZoneParams,
} from "../types/requestInputs";
import {
    GetPlanLanguagesResponse,
    GetStoryByIdResponse,
    GetStoryLanguagesResponse,
    GetSubplanbyIdResponse,
    GetZoneByIdResponse,
    GetZoneLanguagesResponse,
    GetZonesAndRoomsResponse,
    SaveStoryResponse,
    SaveSubplanResponse,
    SaveZonesResponse,
} from "../types/requestsOutputs";
import { MessageResponse } from "../types/types";
import { fetchAPI } from "./utils";

export const getPlanLanguages = async ({
    token,
    subplanId,
}: GetPlanLanguagesParams): Promise<GetPlanLanguagesResponse> => {
    return fetchAPI<GetPlanLanguagesResponse>("/get-subplan-languages", "POST", { subplanId }, token);
};

// Get available story languages
export const getStoryLanguages = async ({
    token,
    clickableZoneId,
}: GetStoryLanguagesParams): Promise<GetStoryLanguagesResponse> => {
    return fetchAPI<GetStoryLanguagesResponse>("/get-story-languages", "POST", { clickableZoneId }, token);
};

// Get story details by ID
export const getStoryById = async ({
    token,
    trackId,
    clickableZoneId,
    language,
}: GetStoryByIdParams): Promise<GetStoryByIdResponse> => {
    return fetchAPI<GetStoryByIdResponse>(
        "/get-story-by-language",
        "POST",
        { trackId, clickableZoneId, language },
        token,
    );
};

// Save a story
export const saveStory = async ({
    token,
    trackId,
    clickableZoneId,
    subplanId,
    zoneId,
    language,
    name,
    text,
    audio,
    pictures,
    coordX,
    coordY,
    position,
}: SaveStoryParams): Promise<SaveStoryResponse> => {
    return fetchAPI<SaveStoryResponse>(
        "/save-story",
        "POST",
        {
            trackId,
            clickableZoneId,
            subplanId,
            zoneId,
            language,
            name,
            text,
            audio,
            pictures,
            coordX,
            coordY,
            position,
        },
        token,
    );
};

// Delete a story
export const deleteStory = async ({ token, trackId, clickableZoneId }: DeleteStoryParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/delete-story", "POST", { trackId, clickableZoneId }, token);
};

// Delete a zone from a track
export const deleteZone = async ({ token, trackId, zoneId }: DeleteZoneParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/delete-zone", "POST", { trackId, zoneId }, token);
};

// Delete a subplan from a track
export const deleteSubplan = async ({ token, trackId, subplanId }: DeleteSubplanParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/delete-subplan", "POST", { trackId, subplanId }, token);
};

export const getSubplanbyId = async ({
    token,
    trackId,
    subplanId,
    language,
}: GetSubplanbyIdParams): Promise<GetSubplanbyIdResponse> => {
    return fetchAPI<GetSubplanbyIdResponse>(
        "/get-subplans-by-language",
        "POST",
        { trackId, subplanId, language },
        token,
    );
};

export const saveGroupedSubPlan = async ({
    token,
    trackId,
    groupedSubplans,
    groupedZones,
}: SaveGroupedSubPlanParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>(
        "/save-grouped-subplans",
        "POST",
        { trackId, groupPlans: groupedSubplans, groupZones: groupedZones },
        token,
    );
};

export const getZoneById = async ({
    token,
    trackId,
    zoneId,
    language,
}: GetZoneByIdParams): Promise<GetZoneByIdResponse> => {
    return fetchAPI<GetZoneByIdResponse>("/get-zone-by-language", "POST", { trackId, zoneId, language }, token);
};

export const saveZone = async ({
    token,
    trackId,
    zoneId,
    language,
    name,
    picture,
    position,
    subPlanId,
}: SaveZoneParams): Promise<SaveZonesResponse> => {
    return fetchAPI<SaveZonesResponse>(
        "/save-zone",
        "POST",
        { trackId, zoneId, language, name, picture, position, subPlanId },
        token,
    );
};

export const getZoneLanguages = async ({
    token,
    zoneId,
}: GetZoneLanguagesParams): Promise<GetZoneLanguagesResponse> => {
    return fetchAPI<GetZoneLanguagesResponse>("/get-zone-languages", "POST", { zoneId }, token);
};

export const saveSubPlan = async ({
    token,
    trackId,
    subplanId,
    language,
    planUrl,
    floorNumber,
    roomNumber,
    name,
    planByLanguageUrl,
}: SaveSubPlanParams): Promise<SaveSubplanResponse> => {
    return fetchAPI<SaveSubplanResponse>(
        "/save-subplan",
        "POST",
        { trackId, subplanId, language, planUrl, floorNumber, roomNumber, name, planByLanguageUrl },
        token,
    );
};

export const getZonesAndRooms = async ({
    token,
    trackId,
}: GetZonesAndRoomsParams): Promise<GetZonesAndRoomsResponse> => {
    return fetchAPI<GetZonesAndRoomsResponse>("/get-zones-and-rooms", "POST", { trackId }, token);
};
